import { isDisabled } from "@testing-library/user-event/dist/cjs/utils/index.js";
import Buttons from "../../../../../components/ui/button/Buttons";
import { FormFieldTypes } from "../../../../../data/formFieldType";

export const NewEmployeeFormData = {
  name: "NewEmployeeFormData",
  initialState: {
    searchEmailAddress:"",
    firstName: "",
    salutationId: null,
    lastName: "",
    email: "",
    designation: "",
    jobLevelId: "",
    jobFunctionId: "",
    gmpCertification: "",
    contactNumber: "",
    contactNumberId:null,
    isUpcomingEvent: true,
    isMonthlyBulletin: true,
    isSectorUpdate: true,
  },

  formFields: [
     {
      id: "searchEmailAddress",
      lable: "Email Address",
      Field_Name: "Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "searchEmailAddress",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "email" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
     {
      id: "searchEmailButton",
      fieldType: FormFieldTypes.COMPONENT,
      additionalComponent: (
        <Buttons
          buttonText="Search"
          buttonTypeClassName="success-btn d-block"
        />
      ),
      style: {
        containerCss: "col-md-6 mt-30-67 ",
      },
    },
    {
      id: "salutationId",
      lable: "First Name or Given Name",
      Field_Name: "First Name or Given Name",
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["salutationId", "firstName"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },

    // LAST NAME
    {
      id: "lastName",
      lable: "Last Name or Surname",
      Field_Name: "Last Name or Surname",
      fieldType: FormFieldTypes.INPUT,
      dataField: "lastName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,

      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-3" },
    },

    // EMAIL ADDRESS
    {
      id: "email",
      lable: "Email Address",
      Field_Name: "Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "email",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }, { type: "email" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },

    // GMP CERTIFICATION
    // {
    //   id: "gmpCertification",
    //   lable: "GMP Certification: GMA",
    //   Field_Name: "gmpCertification",
    //   fieldType: FormFieldTypes.INPUT,
    //   dataField: "gmpCertification",
    //   fieldSetting: {
    //     infoText:
    //       "This label will be displayed after verification of email address with GMP database",
    //   },
    //   style: { containerCss: "col-md-6 mb-3" },
    // },

     {
      id: "gmpCertification",
      lable: "GMP Certification",
      Field_Name: "GMP Certification",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "gmpCertification",
      fieldSetting: {
          formTitle: "GMP Certification : -",
        },
     style: { containerCss: "col-md-6 mb-3 mt-3 custom-text-green-center" }
    },

    // DESIGNATION
    {
      id: "designation",
      lable: "Designation",
      Field_Name: "Designation",
      fieldType: FormFieldTypes.INPUT,
      dataField: "designation",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-3" },
    },

    // CONTACT NUMBER
    {
      id: "contactNumber",
      lable: "Contact Number",
      Field_Name: "Contact Number",
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["contactNumberId", "contactNumber"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-3" },
    },

    // JOB LEVEL
    {
      id: "jobLevelId",
      lable: "Job Level",
      Field_Name: "Job Level",
      fieldType: FormFieldTypes.SELECT,
      dataField: "jobLevelId",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },

    // JOB FUNCTION
    {
      id: "jobFunctionId",
      lable: "Job Function",
      Field_Name: "Job Function",
      fieldType: FormFieldTypes.SELECT,
      dataField: "jobFunctionId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },


    {
      id: "isMailingList",
      lable: "Mailing List",
      Field_Name: "isMailingList",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "Mailing List",
      fieldSetting: {
          formTitle: "Mailing List",
        },
      style: {
        containerCss:"col-md-12 mb-2 custom-text-green",
        // onClick: "toggleMailingList()",
      },
    },

    // MAILING LIST CHECKBOXES
    {
      id: "isUpcomingEvent",
      lable: "Upcoming Events",
      Field_Name: "Upcoming Events",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "isUpcomingEvent",
      style: { containerCss: "col-md-3 mb-3" },
    },
    {
      id: "isMonthlyBulletin",
      lable: "Monthly Bulletin",
      Field_Name: "Monthly Bulletin",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "isMonthlyBulletin",
      style: { containerCss: "col-md-3 mb-3" },
    },
    {
      id: "isSectorUpdate",
      lable: "BE Sector Updates",
      Field_Name: "BE Sector Updates",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "isSectorUpdate",
      style: { containerCss: "col-md-3 mb-3" },
    },
  ],

  formSetting: {
    isViewOnly: false,
    submitButtonText: "Submit",
  },
};



export const EditEmployeeFormData = {
  name: "NewEmployeeFormData",
  initialState: {
    firstName: "",
    salutationId: null,
    lastName: "",
    email: "",
    designation: "",
    jobLevelId: "",
    jobFunctionId: "",
    gmpCertification: "",
    contactNumber: "",
    contactNumberId:null,
    isUpcomingEvent: true,
    isMonthlyBulletin: true,
    isSectorUpdate: true,
  },

  formFields: [
    // FIRST NAME
    {
      id: "salutationId",
      lable: "First Name or Given Name",
      Field_Name:"First Name or Given Name",
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["salutationId", "firstName"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },

    // LAST NAME
    {
      id: "lastName",
      lable: "Last Name or Surname",
      Field_Name: "Last Name or Surname",
      fieldType: FormFieldTypes.INPUT,
      dataField: "lastName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,

      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-3" },
    },

    // EMAIL ADDRESS
    {
      id: "email",
      lable: "Email Address",
      Field_Name: "Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "email",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        isDisable:true
      },
      // validation: [{ type: "require" }, { type: "email" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },

    // GMP CERTIFICATION
    // {
    //   id: "gmpCertification",
    //   lable: "GMP Certification: ",
    //   Field_Name: "gmpCertification",
    //   fieldType: FormFieldTypes.,
    //   dataField: "gmpCertification",
    //   fieldSetting: {
    //     infoText:
    //       "This label will be displayed after verification of email address with GMP database",
    //   },
    //   style: { containerCss: "col-md-6 mb-3" },
    // },


     {
      id: "emailSearch",
      lable: "GMP Certification",
      Field_Name: "GMP Certification",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "emailSearch",
      fieldSetting: {
          formTitle: "GMP Certification : - ",
        },
     style: { containerCss: "col-md-6 mb-3 mt-3 custom-text-green-center" }
    },

    // DESIGNATION
    {
      id: "designation",
      lable: "Designation",
      Field_Name: "Designation",
      fieldType: FormFieldTypes.INPUT,
      dataField: "designation",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-3" },
    },

    // CONTACT NUMBER
    {
      id: "contactNumber",
      lable: "Contact Number",
      Field_Name: "Contact Number",
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["contactNumberId", "contactNumber"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
         maxLength: null
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-3" },
    },

    // JOB LEVEL
    {
      id: "jobLevelId",
      lable: "Job Level",
      Field_Name: "Job Level",
      fieldType: FormFieldTypes.SELECT,
      dataField: "jobLevelId",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },

    // JOB FUNCTION
    {
      id: "jobFunctionId",
      lable: "Job Function",
      Field_Name: "Job Function",
      fieldType: FormFieldTypes.SELECT,
      dataField: "jobFunctionId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },


   {
      id: "isMailingList",
      lable: "Mailing List",
      Field_Name: "isMailingList",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "Mailing List",
      fieldSetting: {
          formTitle: "Mailing List",
        },
      style: {
        containerCss:"col-md-12 mb-2 custom-text-green",
        // onClick: "toggleMailingList()",
      },
    },

    // MAILING LIST CHECKBOXES
    {
      id: "isUpcomingEvent",
      lable: "Upcoming Events",
      Field_Name: "Upcoming Events",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "isUpcomingEvent",
      style: { containerCss: "col-md-3 mb-3" },
    },
    {
      id: "isMonthlyBulletin",
      lable: "Monthly Bulletin",
      Field_Name: "Monthly Bulletin",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "isMonthlyBulletin",
      style: { containerCss: "col-md-3 mb-3" },
    },
    {
      id: "isSectorUpdate",
      lable: "BE Sector Updates",
      Field_Name: "BE Sector Updates",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "isSectorUpdate",
      style: { containerCss: "col-md-3 mb-3" },
    },
  ],

  formSetting: {
    isViewOnly: false,
    submitButtonText: "Submit",
  },
};